import axios from "axios";
import { caseManagementUrl, deleteDocumentService, downloadCaseForClientService, downloadCaseService, downloadCorporateClients, downloadIndividualClients, uploadCaseForClientService, uploadCaseService, uploadCorporateClients, uploadIndividualClients } from "../../config";
import { generateAndExecuteMutation } from "../Axios/DynamicService";
import { Typography } from "@mui/material";


const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  return {
    Authorization: formattedToken,
    "Content-Type": "application/json",
  };
};

const uploadDocumentsAuthHeaders = () => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  return {
    Authorization: formattedToken,
    "Content-Type": "multipart/form-data",
  };
};
const downloadDocumentsAuthHeaders = () => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  return {
    Authorization: formattedToken,
    "Content-Type": "application/json", // Set this to JSON for download requests
  };
};

export async function markTaskDone(id) {
    try {  
        const mutationData = {
            id
        };
    const response = await generateAndExecuteMutation(
        "markTaskDone",
        mutationData,
      "task",
      caseManagementUrl.uri
    );
        if (Object.values(response)[0] != null) { }
        return true;
    }
    catch (error) {
        return false
}
    

}

export async function deleteDocument(fileName, documentId) {
  const baseurldelete = deleteDocumentService.uri;
     const headers = getAuthHeaders();
  const postData = {
    fileName,
    documentId,
  };

  try {
    const response = await axios.post(baseurldelete, postData, { headers });
    return response;
  } catch (error) {
    return error.code;
  }
}

export async function uploadCasefile(file) {
  const baseurlupload = uploadCaseService.uri;
     const headers = uploadDocumentsAuthHeaders();
  const postData = {
    file
  };

  try {
    const response = await axios.post( baseurlupload, postData, { headers });
    return response;
  } catch (error) {
    return error.code;
  }
}

export async function uploadCaseForClientfile(File, ClientType, ClientId) {
  const  baseurlupload = uploadCaseForClientService.uri;
     const headers = uploadDocumentsAuthHeaders();
  const postData = {
    File,
    ClientType,
    ClientId
  };

  try {
    const response = await axios.post( baseurlupload, postData, { headers });
    return response;
  } catch (error) {
    return error.code;
  }
}
export const LeaveBalanceItem = ({ leaveType, balance }) => {
  return (
    <>
      <Typography variant="h5" component="div">
        {leaveType}
      </Typography>
      <Typography sx={{ mb: 1.5 }} color="text.secondary">
        {balance}
      </Typography>
    </>
  );
};

export async function uploadIndividualClient(file) {
  const  baseurlupload = uploadIndividualClients.uri;
     const headers = uploadDocumentsAuthHeaders();
  const postData = {
    file
  };

  try {
    const response = await axios.post( baseurlupload, postData, { headers });
    return response;
  } catch (error) {
    return error.code;
  }
};

export async function uploadCorporateClient(file) {
  const  baseurlupload = uploadCorporateClients.uri;
     const headers = uploadDocumentsAuthHeaders();
  const postData = {
    file
  };

  try {
    const response = await axios.post( baseurlupload, postData, { headers });
    return response;
  } catch (error) {
    return error.code;
  }
};

export async function downloadCaseForClientFile() {
  const headers = downloadDocumentsAuthHeaders();
  try {
    const response = await axios.get(downloadCaseForClientService.uri, { headers, responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'CaseForClientTemplate.xlsx');
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    console.error('Download error:', error);
  }
}

export async function downloadCaseFile() {
  const headers = downloadDocumentsAuthHeaders();
  try {
    const response = await axios.get(downloadCaseService.uri, { headers, responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'CaseTemplate.xlsx');
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    console.error('Download error:', error);
  }
}

export async function downloadIndividualClientFile() {
  const headers = downloadDocumentsAuthHeaders();
  try {
    const response = await axios.get(downloadIndividualClients.uri, { headers, responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'IndividualClientTemplate.xlsx');
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    console.error('Download error:', error);
  }
}

export async function downloadCorporateClientFile() {
  const headers = downloadDocumentsAuthHeaders();
  try {
    const response = await axios.get(downloadCorporateClients.uri, { headers, responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'CorporateClientTemplate.xlsx');
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    console.error('Download error:', error);
  }
}

export async function generateReports(parameters, reportUrl) {
  const headers = getAuthHeaders();
  const base_url = reportUrl;
  const postData = parameters;

  try {
    const response = await axios.post(base_url, postData, { headers });
    return response;
  } catch (error) {
    return error.code;
  }
}

export async function generateReport(formData, reportUrl, setLoading) {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  const headers = {
    "Content-Type": "application/json",
    // Uncomment the following lines if you need these headers
    Authorization: formattedToken,
    "Access-Control-Allow-Headers": "authorization,content-type",
    "Access-Control-Allow-Methods": "POST",
    "Access-Control-Allow-Origin": "*",
    Origin: "https://matrix.mcb.co.ke",
    referrerPolicy: "no-referrer-when-downgrade",
  };

  try {
    // Start the loading animation
    setLoading(true);

    const response = await fetch(reportUrl, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response;
  } catch (error) {
    console.error("Error:", error);
    return error;
  } finally {
    // Stop the loading animation
    setLoading(false);
  }
}